<template>
    <div>
        <Loader v-if="loading" :min-height="'100%'"></Loader>
        <div v-for="(detail, index) in details" :key="index">
            <div class="flex mb-2">
                <div class="flex-8 font-weight-bold">{{ detail.event }}</div>
                <div class="detail-number flex-4">{{ detail.value }}</div>
                <div class="detail-number flex-4">{{ detail.percentage }}%</div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from "@/components/Loader";

export default {
    name: "conversion",

    components: {
        Loader,
    },

    data: function () {
        return {
            details: [],
        };
    },

    watch: {
        conversion(val) {
            this.getPercentage(val);
        },
    },

    props: {
        conversion: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        findBig(text) {
            let findIndex = null;
            let temp = text;

            for (let i = 0; i < text.length; i++) {
                if (
                    text.charAt(i) === text.charAt(i).toUpperCase() &&
                    text.indexOf(text.charAt(i)) > 0
                ) {
                    findIndex = text.indexOf(text.charAt(i));
                }
            }

            if (findIndex) {

                temp = temp.split("");
                temp[findIndex] = ` ${temp[findIndex]}`;

                return temp.join("")
            }

            return temp;
        },

        getPercentage(arr) {
            let result = [], sum = 0;

            for (let i = 0; i < arr.length; i++) {

                if (arr[i][0] === 'Users') {
                    sum = arr[i][1]
                }
            }

            for (let i = 0; i < arr.length; i++) {
                const key = this.findBig(arr[i][0]);
                const value = arr[i][1];
                result.push({ event: key, value: value });
            }

            result.forEach((event, index) => {

                if (index === 0 && event.value) event.percentage = 100;

                if (index > 0) event.percentage = Number(((event.value / sum) * 100).toFixed(2));

                event.percentage = isNaN(event.percentage) ? 0 : event.percentage;

            }, {});

            this.details = result;

            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
    .flex {
        display: flex;
    }

    .flex-4 {
        flex: 0.4;
    }

    .flex-8 {
        flex: 0.8;
    }

    .detail-number {
        text-align: end;
    }

    .value {
        text-align: end;
    }


    @media screen and (max-width: 960px) {
        .graph-footer > div {
            margin-right: 0.5rem;
        }

        .detail-number {
            flex: 0.3;
        }
    }

    @media screen and (max-width: 400px) {
        .value {
            text-align: right;
        }
    }
</style>
